import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { AuthorizationService, GlobalService } from "./../../../shared/index";

@Component({
  templateUrl: "./home.html",
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  private authorizationSubscription: Subscription;
  private versionSubscription: Subscription;

  public showLoginModal = false;
  public isLoggedIn = false;
  public uwpVersion = "";
  public uwpslVersion = "";
  public appInstallerLocation = "";
  public isProduction = true;
  public isStaging = false;
  public isDevelopment = false;

  constructor(
    private _authorizationService: AuthorizationService,
    private _globalService: GlobalService
  ) {}

  ngOnInit() {
    this.isLoggedIn = this._authorizationService.authenticated;
    this.authorizationSubscription =
      this._authorizationService.authenticateComplete.subscribe((info: any) => {
        this.isLoggedIn = true;
      });

    this.versionSubscription = this._globalService.versionChange.subscribe(
      (info: any) => {
        this.uwpVersion = info.Data.uVersion;
        this.uwpslVersion = info.Data.uslVersion;
      }
    );

    //dev notes:
    // updating the appInstallerLocation URL programatically (either here or in html) result in an url-unsafe flag being added in browswer. Url needs to be

    //2024-01-03 - removed ms-appinstaller prefix because windows is now blocking by default
    //this.appInstallerLocation = "ms-appinstaller:?source=" + window.location.origin  + "/downloads/uwp-installer/ProManualInstaller.appinstaller";
    this.appInstallerLocation =
      window.location.origin +
      "/downloads/uwp-installer/ProManualInstaller.appinstaller";

    if (
      window.location.origin.toLowerCase().includes("kmcpmedevweb") ||
      window.location.origin.toLowerCase().includes("kmcpmestgweb")
    ) {
      this.isProduction = false;
    }

    this.isStaging = window.location.origin
      .toLowerCase()
      .includes("kmcpmestgweb");
    this.isDevelopment = window.location.origin
      .toLowerCase()
      .includes("kmcpmedevweb");
  }

  ngOnDestroy() {
    this.versionSubscription.unsubscribe();
  }

  public showLogin(): void {
    this.showLoginModal = true;
  }
}
